import type { OrderBook } from "@/components/features/trade/OrderBook/types";

/**
 * Bucket every level into `precision`-wide price buckets, summing amounts.
 * Returns bids sorted descending, asks ascending — the order TV order-book
 * panels expect. Integer scaling avoids float drift on tight ticks.
 */
export function aggregateOrderBookByPrecision(orderBook: OrderBook | null, precision: number): OrderBook | null {
  if (!orderBook) return null;

  const bucket = (levels: [number, number][], sortDescending: boolean): [number, number][] => {
    const aggregated = new Map<number, number>();
    const scale = 1 / precision;
    for (const [price, amount] of levels) {
      const roundedPrice = Math.round(price * scale) / scale;
      aggregated.set(roundedPrice, (aggregated.get(roundedPrice) ?? 0) + amount);
    }
    const result = Array.from(aggregated.entries());
    return sortDescending ? result.sort((a, b) => b[0] - a[0]) : result.sort((a, b) => a[0] - b[0]);
  };

  return {
    bids: bucket(orderBook.bids, true),
    asks: bucket(orderBook.asks, false),
    timestamp: orderBook.timestamp,
  };
}
